import { Tag, Typography, theme } from "antd";
import { ReactNode } from "react";

export interface ManageStatusBannerProps {
  /** Tag colour of the status chip. */
  readonly tagColor?: string;
  /** The status label inside the chip. */
  readonly status?: ReactNode;
  /** Extra chips between the status chip and the guidance (e.g. a severity tag). */
  readonly chips?: ReactNode;
  /** One-line contextual guidance for the current state. */
  readonly guidance?: ReactNode;
  /** Trailing content after the guidance (pushed right by the guidance's flex). */
  readonly extra?: ReactNode;
  /** Dense wrapping row for banners that carry several chips/actions. */
  readonly wrap?: boolean;
}

/**
 * The Manage-dialog status banner: a status Tag plus contextual guidance on the quaternary
 * fill, with optional extra chips/actions around the guidance.
 */
function ManageStatusBanner(props: ManageStatusBannerProps) {
  const { token } = theme.useToken();

  return (
    <div
      className={
        props.wrap
          ? "mb-4 flex flex-row flex-wrap items-center gap-2 p-3"
          : "mb-4 flex flex-row items-center gap-3 p-3"
      }
      style={{
        backgroundColor: token.colorFillQuaternary,
        borderRadius: token.borderRadius,
      }}
    >
      <Tag color={props.tagColor} className="m-0">
        {props.status}
      </Tag>
      {props.chips}
      <Typography.Text type="secondary" className="flex-auto">
        {props.guidance}
      </Typography.Text>
      {props.extra}
    </div>
  );
}

export default ManageStatusBanner;
